/** Узел JSON-LD: обычный объект с "@type" и полями schema.org */
export type JsonLdNode = Record<string, unknown>;

export const SCHEMA_CONTEXT = "https://schema.org";

/**
 * Убирает из узла пустые поля: null, undefined, пустые строки и пустые
 * массивы. В разметку идут только реальные данные из запросов, «пустых»
 * полей у schema.org быть не должно.
 */
export function compact<T extends JsonLdNode>(node: T): T {
  const result: JsonLdNode = {};
  for (const [key, value] of Object.entries(node)) {
    if (value === null || value === undefined || value === "") continue;
    if (Array.isArray(value) && value.length === 0) continue;
    result[key] = value;
  }
  return result as T;
}

/**
 * JSON для <script type="application/ld+json">. Содержимое script-тега
 * браузер не декодирует, поэтому «</script>» из названия контента закрыл
 * бы тег и дал XSS: <, > и & пишем escape-последовательностями JSON, они
 * остаются валидным JSON и не трогают HTML-парсер. U+2028/2029 экранируем
 * ради старых движков, где они ломают строку.
 */
export function serializeJsonLd(nodes: JsonLdNode[]): string {
  const document = { "@context": SCHEMA_CONTEXT, "@graph": nodes };
  return JSON.stringify(document)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}
